import React from 'react';
import { Link } from 'react-router';
import { IntercomAPI } from 'react-intercom';
import background from '../../pages/WebApp/assets/footer.png';
import styles from './styles.scss';

function HomeFooter() {
  return (
    <div className={styles.container} style={{ background: `url(${background})` }}>
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className="row">
            <div className="col-sm-12 text-center mt100">
              <h1>Need help finding a designer?</h1>
              <h3 className={`${styles.subHeading} alt-text ls1`}>
                Submit a brief and get access to our network of designers.
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 col-md-8 col-sm-9 col-center col-xs-12 mt50 mb100">
              <div className="row">
                <div className="col-sm-5 col-sm-offset-1">
                  <a className="btn btn-dc-blue btn-block" onClick={() => IntercomAPI('show')}>
                    CHAT WITH US
                  </a>
                </div>
                <div className="col-sm-5">
                  <Link to="/get-started" className="btn btn-dc-transparent btn-block">
                    SUBMIT A BRIEF
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeFooter;



// WEBPACK FOOTER //
// ./src/components/HomeFooter/index.js